"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorText = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const ErrorText = ({ name, className, children }) => {
    return (react_1.default.createElement("span", { className: (0, classnames_1.default)('text-xs text-red-5', className), "data-name": name }, children));
};
exports.ErrorText = ErrorText;
